
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.CardField = function (config) {

    config = config || {};

    this.attribute = config.attribute || "";
    this.isFront = config.isFront || false;
    this.fieldPosition = config.fieldPosition || 0;
    this.field = config.field;
    this.clickHandler = config.clickHandler;

    if (this.field && this.clickHandler) {
        this.field.addClickEventListener(function () {
            this.clickHandler(this);
        }.bind(this));
    }

    this.setValue = function (cardField) {

        this.attribute = cardField.attribute;
        this.isFront = cardField.isFront;
        this.fieldPosition = cardField.fieldPosition;

        if (cardField.field) {

            if (this.field && this.field.setSelectedField) {
                this.field.setSelectedField(cardField.field);
            } else {

                if (cardField.field.getValue) {
                    this.field = cardField.field.getValue();
                } else {
                    this.field = cardField.field;
                }
            }

        } else {

            if (this.field && this.field.setSelectedField) {
                this.field.setSelectedField({ name: " " });
            }

        }
    };

    this.getValue = function () {

        var field = this.field.getValue();

        return (field) ? {
            id: this.id,
            isFront: this.isFront,
            fieldPosition: this.fieldPosition,
            field: {
                id: field.id
            },
            attribute: this.attribute
        } : {
            field: {}
        };

    };

};